import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconBuildingBridge, IconEye, IconListTree } from '@tabler/icons-react';
import { lazy } from 'react';

import moduleInfo from '../module.json';

/**
 * Клиентская часть ECDM: реестр проектов и каталог разделов.
 *
 * Проекты не регистрируются отдельными пунктами меню: реестр может быть
 * большим, и динамическая навигация по каждому проекту сделала бы меню
 * неуправляемым. Карточка открывается скрытым роутом с параметром.
 */
export async function setup(app: AppRuntime): Promise<void> {
  const ecdm = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
    navigationOrder: 20,
  });

  const groupEcdm = ecdm.createNavigationGroup({
    key: 'ecdm',
    label: 'Проектирование',
    icon: IconBuildingBridge,
    order: 1,
  });

  ecdm.useNavigation([
    {
      group: groupEcdm,
      icon: IconListTree,
      label: 'Задачи и стоимость',
      url: '/ecdm/tasks',
      component: lazy(() => import('./components/reports/TaskReport')),
      menuOrder: 2.5,
    },
    {
      group: groupEcdm,
      icon: IconListTree,
      label: 'Работы по исполнителям',
      url: '/ecdm/executors',
      component: lazy(() => import('./components/reports/ExecutorReport')),
      menuOrder: 2,
    },
    {
      group: groupEcdm,
      icon: IconBuildingBridge,
      label: 'Проекты',
      url: '/ecdm/projects',
      component: lazy(() => import('./components/projects/ProjectsList')),
      menuOrder: 1,
    },
    {
      group: groupEcdm,
      icon: IconListTree,
      label: 'Каталог разделов',
      url: '/ecdm/catalog',
      component: lazy(() => import('./components/catalog/CatalogPage')),
      menuOrder: 3,
    },
    {
      icon: IconEye,
      label: 'Карточка проекта',
      url: '/ecdm/projects/:id',
      component: lazy(() => import('./components/projects/ProjectViewPage')),
      hiddenFromMenu: true,
    },
  ]);
}
